import errorGenerator from "./customError";
import { HttpStatusCode } from "axios";

const ERROR_MESSAGES = {
  MISSING_DATA: "One of the required fields is missing."
}

export const MissingDataError = errorGenerator.createApiErrorClass(
  ERROR_MESSAGES.MISSING_DATA,
  HttpStatusCode.BadRequest
)